import { Route } from '@angular/router';
import { ContractNavbarComponent } from '../../../../../layouts';
import {
    TenderContractResolver,
    TenderContractRoundResolver,
    TenderContractSuppliersResolver
} from '../../../../resolvers';
import { contractDashboardRoute } from './children';

export const tenderContractRoute: Route = {
    path: 'locations/:id',
    //canActivate: [TenderStatusGuard],
    component: ContractNavbarComponent,
    resolve: {
        contract: TenderContractResolver,
    },
    children: [
        {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'prefix'
        },
        contractDashboardRoute
    ]
};
